module.exports = __webpack_public_path__ + "img/Invasion-ASHN_GSE227469.1b896c72.png";